import { z } from "zod";

export const contentLanguageSchema = z.object({
  code: z.string(),
  baseCode: z.string().or(z.null()).optional(),
  language: z.object({
    code: z.string(),
    title: z.string(),
  }),
  isPrimary: z.boolean().optional(),
});

export const contentLanguageCreateSchema = z.object({
  code: z.string(),
  baseCode: z.string().or(z.null()).optional(),
});

export const contentLanguageUpdateSchema = z.object({
  baseCode: z.string().or(z.null()),
});

export type ContentLanguage = z.infer<typeof contentLanguageSchema>;

export type ContentLanguageCreate = z.infer<typeof contentLanguageCreateSchema>;

export type ContentLanguageUpdate = z.infer<typeof contentLanguageUpdateSchema>;
